import { BCExtremeGridEntities } from '@bimser/components';
import DataGrid from '../..';
import { getColumnEditingEnabled, getColumnSorting, getColumnVisible } from './getColumnProperties';
import _isEqual from 'lodash/isEqual';

function controlColumnVariables(
	this: DataGrid,
	__columns: Array<BCExtremeGridEntities.IExtremeGridColumn>
) {
	if (this.columns?.length != __columns?.length) {
		return { refetch: true };
	}
	return {
		refetch: false,
		changes: this.columns.reduce((result, column, index) => {
			const __column = __columns.find(__c => __c.name == column.name);
			const change = {
				visible: {
					isChanged: __column.visible != getColumnVisible.call(this, column),
					value: getColumnVisible.call(this, column)
				},
				order: { isChanged: __column.order !== index, value: index },
				editingEnabled: {
					isChanged: __column.editingEnabled != getColumnEditingEnabled(column),
					value: getColumnEditingEnabled(column)
				},
				sorting: {
					isChanged: !_isEqual(__column.sorting, getColumnSorting.call(this, column)),
					value: getColumnSorting.call(this, column)
				}
			};

			if (Object.values(change).some(({ isChanged }) => isChanged)) {
				result[column.name] = change;
			}
			return result;
		}, {})
	};
}

export { controlColumnVariables };
